import { HttpClient } from '@angular/common/http';

import { HttpUtils } from '../utils/httpUtils';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class CalibrationPlaceService {

    constructor(private http: HttpClient) {
    }

    findAll(): Observable<any> {
        const url = environment.coreUrl + '/calibrationPlace/';

        return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }
}
